<template>
  <div class="mini-program-config">
    <a-card title="小程序配置" :bordered="false" class="mb-4">
      <a-form ref="formRef" :model="form" :rules="rules" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="小程序AppID" field="appId">
              <a-input v-model="form.appId" placeholder="请输入小程序AppID" />
            </a-form-item>
          </a-col>
          
          <a-col :span="24">
            <a-form-item label="消息加解密方式" field="encryptMode">
              <a-radio-group v-model="form.encryptMode" type="button">
                <a-radio value="plain">明文模式</a-radio>
                <a-radio value="compatible">兼容模式</a-radio>
                <a-radio value="secure">安全模式</a-radio>
              </a-radio-group>
              <div class="form-item-description">小程序消息推送中的消息加密方式，暂时仅支持明文模式</div>
            </a-form-item>
          </a-col>
          
          <a-col :span="24">
            <a-form-item label="EncodingAESKey" field="encodingAESKey">
              <a-input v-model="form.encodingAESKey" placeholder="消息加密密钥由43位字符组成，字符范围为A-Z,a-z,0-9" />
            </a-form-item>
          </a-col>
        </a-row>
        
        <a-form-item>
          <a-button type="primary" @click="handleSubmit" :loading="loading">提交</a-button>
          <a-button style="margin-left: 16px" @click="handleReset">重置</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import { getMiniProgramConfig, saveMiniProgramConfig } from '@/apis/system/mini-program-config';

export default {
  name: 'MiniProgramConfig',
  data() {
    return {
      loading: false,
      form: {
        appId: '',
        encryptMode: 'plain',
        encodingAESKey: ''
      },
      encryptModeMap: {
        'plain': '明文模式',
        'compatible': '兼容模式',
        'secure': '安全模式'
      },
      rules: {
        appId: [
          { required: true, message: '请输入小程序AppID' }
        ],
        encodingAESKey: [
          { 
            required: true, 
            message: '请输入EncodingAESKey',
            validator: (value, cb) => {
              if (!value) {
                cb('请输入EncodingAESKey');
              } else if (value.length !== 43) {
                cb('EncodingAESKey必须由43位字符组成');
              } else {
                cb();
              }
            }
          }
        ]
      }
    };
  },
  mounted() {
    // 页面加载时获取已有配置
    this.loadConfig();
  },
  methods: {
    // 加载配置
    async loadConfig() {
      try {
        const res = await getMiniProgramConfig();
        console.log('获取小程序配置响应:', res);
        // 修复：使用正确的成功状态码判断（0表示成功）
        if (res.code === 0) {
          // 确保即使res.data为null也能正确处理
          const data = res.data || {};
          console.log('配置数据:', data);
          
          // 重置表单
          this.form = {
            appId: '',
            encryptMode: 'plain',
            encodingAESKey: ''
          };
          
          // 分别设置每个字段，确保正确处理
          if (data.hasOwnProperty('appId')) {
            this.form.appId = data.appId || '';
          }
          if (data.hasOwnProperty('encryptMode')) {
            this.form.encryptMode = data.encryptMode || 'plain';
          }
          if (data.hasOwnProperty('encodingAESKey')) {
            this.form.encodingAESKey = data.encodingAESKey || '';
          }
          
          console.log('更新后的表单:', this.form);
        } else {
          this.$message.error(res.message || '加载配置失败');
        }
      } catch (err) {
        this.$message.error('加载配置失败: ' + (err.message || '未知错误'));
        console.error('加载小程序配置失败:', err);
      }
    },
    
    // 提交表单
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();
        this.loading = true;
        console.log('提交的表单数据:', this.form);
        
        const res = await saveMiniProgramConfig(this.form);
        console.log('保存配置响应:', res);
        // 修复：使用正确的成功状态码判断（0表示成功）
        if (res.code === 0 && res.data) {
          this.$message.success('配置保存成功');
          // 保存成功后重新加载配置以确保数据同步
          await this.loadConfig();
        } else {
          this.$message.error(res.message || '保存失败');
        }
      } catch (err) {
        this.$message.error('保存配置失败: ' + (err.message || '未知错误'));
        console.error('保存小程序配置失败:', err);
      } finally {
        this.loading = false;
      }
    },
    
    handleReset() {
      this.$refs.formRef.resetFields();
    }
  }
};
</script>

<style scoped>
.form-item-description {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

.mb-4 {
  margin-bottom: 1rem;
}
</style>